import { render, staticRenderFns } from "./ActionDetail.vue?vue&type=template&id=480e1745&scoped=true&"
import script from "./ActionDetail.vue?vue&type=script&lang=js&"
export * from "./ActionDetail.vue?vue&type=script&lang=js&"
import style0 from "./ActionDetail.vue?vue&type=style&index=0&id=480e1745&prod&lang=scss&scoped=true&"
import style1 from "./ActionDetail.vue?vue&type=style&index=1&id=480e1745&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480e1745",
  null
  
)

export default component.exports